import { Button } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { FiEdit2 } from 'react-icons/fi';

export const EditDataBtn = ({ children, ...restProps }: { children: ReactNode; [key: string]: any }) => {
  return (
    <Button variant='linkUnderline' fontSize='xs' color='gray.400' rightIcon={<FiEdit2 />} {...restProps}>
      {children}
    </Button>
  );
};
